import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import Icon from 'react-eva-icons';
// import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from 'reactstrap';
// import SimpleBar from 'simplebar-react';
// import { useDispatch } from 'react-redux';
import logoDarkSm from '@/assets/images/logo-dark-sm.svg';
import logoLight from '@/assets/images/logo-light.svg';
import logoLightSm from '@/assets/images/logo-light-sm.svg';

//import language flag images
// import usFlag from '../../assets/images/flags/us.jpg';
// import russiaFlag from '../../assets/images/flags/russia.jpg';

//user(avatar) Image
// import avatarImage1 from '@/assets/images/users/avatar-1.jpg';
import BreadCrumb from '@/components/Common/BreadCrumb';

// Redux Store
import {
  // showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from '../../store/actions';
import HeaderProfile from './HeaderProfile';
// import { Button } from 'reactstrap';
// import { refreshCache } from '@/store/base/actions';
// import { useTranslation } from 'react-i18next';

const Header = ({ breadCrumbItems, showRightSidebar }) => {
  // const { t } = useTranslation();
  // const dispatch = useDispatch();
  //Seacrh dropdown
  // const [search, setSearch] = useState(false);
  // const toggleSearch = () => {
  //     setSearch(!search);
  // };

  //Language Dropdown
  const [languages, setLanguage] = useState(false);
  const toggleLanguage = () => {
    setLanguage(!languages);
  };

  //Webapps Dropdown
  // const [webapps, setWebapps] = useState(false);
  // const toggleWebapps = () => {
  //     setWebapps(!webapps);
  // };

  //Notification Dropdown
  const [notification, setNotification] = useState(false);
  const toggleNotification = () => {
    setNotification(!notification);
  };

  //scroll navbar
  const [navClass, setnavClass] = useState(false);
  const scrollNavigation = useCallback(() => {
    let scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      if (navClass !== 'sticky') {
        setnavClass('sticky');
      }
    } else {
      if (navClass === 'sticky') {
        setnavClass('');
      }
    }
  }, [navClass]);

  useEffect(() => {
    window.addEventListener('scroll', scrollNavigation, true);
    return () => window.removeEventListener('scroll', scrollNavigation, true);
  }, [scrollNavigation]);

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle('sidebar-enable');
    } else {
      body.classList.toggle('sidebar-enable');
      body.setAttribute('data-sidebar-size', 'lg');
    }
  }

  // const handleClickRefreshCache = async () => {
  //   const res = await refreshCache();
  //   console.log('res', res);
  // };

  return (
    <React.Fragment>
      <header id="page-topbar" className={'isvertical-topbar ' + navClass}>
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoDarkSm} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDarkSm} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-lg">
                  <img src={logoLight} alt="" height="22" />
                </span>
                <span className="logo-sm">
                  <img src={logoLightSm} alt="" height="22" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn topnav-hamburger"
              onClick={() => tToggle()}
            >
              <div className="hamburger-icon open">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>

            <BreadCrumb breadCrumbItems={breadCrumbItems} />
          </div>
          <div className="d-flex">
            {/* <div className="d-flex aic">
              <Button
                color="info"
                type="button"
                className="waves-effect waves-light btn-rounded py-1 px-3 ml-2"
                onClick={handleClickRefreshCache}
              >
                <i className="fas fa-sync-alt fz-90 mr-2" />
                <span>{t('btn_refresh_cache')}</span>
              </Button>
            </div> */}
            <HeaderProfile />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  // showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(Header);
